import { render, staticRenderFns } from "./MensagensDataTable.vue?vue&type=template&id=58e30de2&scoped=true&"
import script from "./MensagensDataTable.vue?vue&type=script&lang=js&"
export * from "./MensagensDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MensagensDataTable.vue?vue&type=style&index=0&id=58e30de2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e30de2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAlert,VCard,VCardText,VDataTable,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
